module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./CisternWalletView.js"));
	}, "CisternWalletView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CisternWalletView!./src/pages/Shop/Member/Wallet/CisternWallet/CisternWalletView.js
// module id = 1984
// module chunks = 367